import React from "react";

/**
 * Estilos propios de las notificaciones de Compras (campana del header +
 * panel desplegable + página "Ver todas"). Reutiliza la paleta violeta del
 * módulo (ver compras.styles.js) para que se sienta parte del mismo sistema.
 */
export const NotificacionesStyles = () => (
    <style>{`
        .notif-bell-wrapper {
            position: relative;
            display: flex;
            align-items: center;
            margin-right: 6px;
        }
        .notif-bell-btn {
            position: relative;
            background: none;
            border: none;
            cursor: pointer;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: #5941A7;
            transition: background .15s ease;
        }
        .notif-bell-btn:hover { background: rgba(89, 65, 167, 0.08); }
        .notif-bell-badge {
            position: absolute;
            top: 3px;
            right: 3px;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            border-radius: 999px;
            background: linear-gradient(135deg, #f38b8a 0%, #e34948 100%);
            color: #fff;
            font-size: 10px;
            font-weight: 700;
            line-height: 16px;
            text-align: center;
            box-shadow: 0 0 0 2px #fff;
        }
        .notif-panel {
            width: 360px;
            max-width: 92vw;
            padding: 0;
            border: none;
            border-radius: 14px;
            box-shadow: 0 12px 32px rgba(45, 30, 90, 0.22);
            overflow: hidden;
        }
        .notif-panel-header {
            background: linear-gradient(135deg, #f6f4ff 0%, #eef2ff 45%, #f0faf9 100%);
            padding: 14px 18px 12px;
            border-bottom: 1px solid rgba(148, 130, 255, 0.2);
        }
        .notif-panel-header-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 4px;
        }
        .notif-panel-title { font-size: 16px; font-weight: 700; color: #2f2657; margin: 0; }
        .notif-pending-tag {
            font-size: 11px;
            font-weight: 700;
            color: #e34948;
            background: rgba(227, 73, 72, 0.12);
            border-radius: 999px;
            padding: 2px 10px;
            letter-spacing: .3px;
        }
        .notif-active-tag {
            font-size: 11.5px;
            font-weight: 600;
            color: #29996a;
            display: flex;
            align-items: center;
            gap: 5px;
        }
        .notif-active-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #29996a;
            box-shadow: 0 0 0 2px rgba(41, 153, 106, 0.25);
        }
        .notif-list {
            max-height: 380px;
            overflow-y: auto;
        }
        .notif-item {
            display: flex;
            gap: 10px;
            padding: 12px 18px;
            border-bottom: 1px solid #f1eefc;
            cursor: pointer;
            position: relative;
            transition: background .12s ease;
        }
        .notif-item:hover { background: #faf9ff; }
        .notif-item.unread { background: #f8f6ff; }
        .notif-item-icon {
            width: 34px;
            height: 34px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            flex-shrink: 0;
        }
        .notif-item-icon.danger { background: rgba(227, 73, 72, 0.14); }
        .notif-item-icon.warning { background: rgba(242, 169, 59, 0.16); }
        .notif-item-icon.success { background: rgba(41, 153, 106, 0.14); }
        .notif-item-icon.info { background: rgba(139, 127, 240, 0.16); }
        .notif-item-body { flex: 1; min-width: 0; }
        .notif-item-top { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
        .notif-item-badge {
            font-size: 10px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: .3px;
            padding: 2px 8px;
            border-radius: 999px;
        }
        .notif-item-badge.danger { color: #e34948; background: rgba(227, 73, 72, 0.12); }
        .notif-item-badge.warning { color: #a15b00; background: rgba(242, 169, 59, 0.18); }
        .notif-item-badge.success { color: #1c6b4d; background: rgba(41, 153, 106, 0.14); }
        .notif-item-badge.info { color: #5941A7; background: rgba(139, 127, 240, 0.14); }
        .notif-item-time { font-size: 11px; color: #9a94b3; flex-shrink: 0; }
        .notif-item-msg { font-size: 13px; color: #3c3560; margin: 4px 0 0; line-height: 1.35; word-break: break-word; }
        .notif-item-msg strong { color: #2f2657; }
        .notif-item-dot {
            position: absolute;
            top: 14px;
            left: 6px;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #5941A7;
        }
        .notif-panel-footer {
            padding: 10px 18px;
            border-top: 1px solid #f1eefc;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        .notif-empty { padding: 34px 18px; text-align: center; color: #9a94b3; font-size: 13px; }

        /* Página "Ver todas" */
        .notif-page-item {
            display: flex;
            gap: 14px;
            padding: 16px 18px;
            border-radius: 12px;
            margin-bottom: 10px;
            background: #fff;
            border: 1px solid #ece9fb;
            box-shadow: 0 2px 8px rgba(94, 84, 200, 0.06);
        }
        .notif-page-item.unread { background: #f8f6ff; border-color: rgba(148, 130, 255, 0.35); }
    `}</style>
);
